<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: betwaym 848032671@qq.com
 * @LastEditTime: 2024-01-29 13:34:52
-->
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled="readonly" :showReturn="false"
      :showEdit="hasBtn('email-history-edit') && mail_type == 2" :show_del="false" @handleEdit="handleEdit">
      <v-btn rounded depressed height="40" v-if="!readonly && mail_type == 2 && hasBtn('resend-email')" @click="reSend"
        color="primary">{{ $t("label_Resend") }}</v-btn>
    </mrc_ess_iconGroup>
    <historyMail :disabled="readonly" @changeReadonly="handleEdit"></historyMail>
  </div>
</template>

<script>
import {
  historyMailList,
  historyMailDetails,
  historyEmailUpdate,
  historyMailResend,
} from "@/service/api/historyMail.js"
import historyMail from "./historyMail.vue"
export default {
  components: {
    historyMail,
  },
  props: {},
  data() {
    return {
      readonly: false,
      list: {},
      mail_type: this.$ls.get("mail_type"),
    }
  },
  computed: {},
  created() { },
  watch: {
    readonly: {
      handler(v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = "label_edit_historical_mail"
          this.$store.commit("set_page_title", "label_edit_historical_mail")
        } else {
          this.$route.meta.title = "label_view_historical_mail"
          this.$store.commit("set_page_title", "label_view_historical_mail")
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy() { },
  methods: {
    reSend() {
      this.$myConfirm({ content: this.$t("label_confirm_to_resend") })
        .then((res) => {
          historyMailResend({ uuid: this.$store.state.uuid }).then((res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              })
              this.$router.push({ name: "historyMail" })
            }
          })
        })
        .catch((err) => { })
    },
    handleEdit() {
      this.readonly = !this.readonly
      this.$store.commit("set_iconstatus", this.readonly)
    },
    // handleDel () {
    //   this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
    //     deleteStaffLeave({ uuid: this.$store.state.uuid }).then(res => {
    //       if (res.code == 200) {
    //         this.$Message({ text: this.$t('message_The_deletion_was_successful') })
    //         this.$router.push({
    //           name: 'staffLeave',
    //           params: {
    //             type: 'del'
    //           }
    //         })
    //       }
    //     })
    //   })
    // },
  },
}
</script>

<style scoped></style>
